// Pop-up: balance adjustments for one customer (add, re-date, delete).
// Part of the Balances page (components/Balances.jsx). Split out 2026-10-14.
import { fmtCycleLabel } from './helpers.js';
import { fmtMoneyRounded as fmtMoney } from '../../utils/money.js';

export default function AdjustmentsModal({ adjAmount, adjBusy, adjDate, adjDescription, adjItems, adjRow, cycleKey, deleteAdjustment, saveAdjustment, setAdjAmount, setAdjDate, setAdjDescription, setAdjRow, to, updateAdjustmentDate }) {
  return (
    <>
      {adjRow && (
        // Backdrop / Close intentionally NOT gated by adjBusy so a
        // hung fetch (e.g. slow schema lookup) can't trap the user
        // in the modal. Suresh 2026-07-08 reported this after the
        // FK-cutover deploy: stuck on a "Saving..." button they
        // hadn't clicked.
        <div className="modal-backdrop" onClick={() => setAdjRow(null)}>
          <div className="modal-card" onClick={e => e.stopPropagation()} style={{ minWidth: 560, maxWidth: 720 }}>
            <h3 style={{ marginTop: 0 }}>Adjustments — {adjRow.customer}</h3>
            <div className="small" style={{ color: '#666', marginBottom: '0.5rem' }}>
              Cycle {fmtCycleLabel(cycleKey)} · Positive = credit (balance goes UP, customer owes less). Negative = charge (balance goes DOWN, customer owes more).
            </div>
            {adjItems.length === 0 && !adjBusy && <div className="small" style={{ color: '#888', padding: '0.5rem 0' }}>No adjustments yet for this customer in this cycle.</div>}
            {adjItems.length > 0 && (
              <table style={{ width: '100%', fontSize: '0.9em', marginBottom: '0.75rem' }}>
                <thead><tr>
                  <th style={{ textAlign: 'left', width: 130 }} title="Posted date -- drives which reconciliation window the adjustment lands in">Date</th>
                  <th style={{ textAlign: 'left' }}>Description</th>
                  <th style={{ textAlign: 'right', width: 100 }}>Amount</th>
                  <th style={{ width: 60 }}></th>
                </tr></thead>
                <tbody>
                  {adjItems.map(a => {
                    // posted_at is a full ISO timestamp; the <input type="date">
                    // only accepts YYYY-MM-DD, so slice off the time portion.
                    const dateStr = a.posted_at ? String(a.posted_at).slice(0, 10) : '';
                    return (
                      <tr key={a.id || Math.random()}>
                        <td>
                          <input type="date" defaultValue={dateStr} disabled={adjBusy}
                            onBlur={e => {
                              const v = e.target.value;
                              if (v && v !== dateStr) updateAdjustmentDate(a.id, v);
                            }}
                            style={{ fontSize: '0.9em', padding: '2px 4px', width: 120 }}
                            title="Change the posted date -- backdating moves this adjustment into a different reconciliation window" />
                        </td>
                        <td>{a.description}</td>
                        <td style={{ textAlign: 'right', color: Number(a.amount) >= 0 ? '#15803d' : '#dc2626' }}>{fmtMoney(a.amount)}</td>
                        <td><button onClick={() => deleteAdjustment(a.id)} disabled={adjBusy}
                          style={{ background: 'transparent', border: 'none', color: '#991b1b', cursor: 'pointer' }}>×</button></td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
            <div style={{ borderTop: '1px solid #eee', paddingTop: '0.75rem' }}>
              <div className="small" style={{ fontWeight: 600, marginBottom: '0.3rem' }}>Add adjustment</div>
              <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'flex-end', flexWrap: 'wrap' }}>
                <label className="small" style={{ width: 130 }}>Date
                  <input type="date" value={adjDate} onChange={e => setAdjDate(e.target.value)}
                    style={{ width: '100%' }}
                    title="Backdate to land the adjustment in a specific reconciliation window" />
                </label>
                <label className="small" style={{ flex: 1, minWidth: 200 }}>Description
                  <input type="text" value={adjDescription} onChange={e => setAdjDescription(e.target.value)}
                    placeholder="e.g. credit for spillage cleanup"
                    style={{ width: '100%' }} />
                </label>
                <label className="small" style={{ width: 130 }}>Amount ($)
                  <input type="number" step="0.01" value={adjAmount} onChange={e => setAdjAmount(e.target.value)}
                    placeholder="-100.00"
                    style={{ width: '100%' }} />
                </label>
                <button className="refresh-btn" onClick={saveAdjustment}
                  disabled={adjBusy || !adjDescription.trim() || adjAmount === '' || !adjDate}
                  style={{ background: '#7c3aed' }}>
                  {adjBusy ? 'Saving…' : 'Add'}
                </button>
              </div>
            </div>
            <div style={{ marginTop: '1rem', textAlign: 'right' }}>
              <button className="refresh-btn" onClick={() => setAdjRow(null)} style={{ background: '#888' }}>Close</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
